var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 14.7283V8.05525C16.5 7.23514 16.1438 6.46096 15.5349 5.95746L11.0465 2.24642C9.84277 1.25119 8.15723 1.25119 6.95353 2.24642L2.46515 5.95746C1.85618 6.46096 1.5 7.23514 1.5 8.05525V14.7283C1.5 15.7068 2.24619 16.5 3.16667 16.5H4.83333C5.75381 16.5 6.5 15.7538 6.5 14.8333V12.0707C6.5 11.0922 7.24619 10.2989 8.16667 10.2989H9.83333C10.7538 10.2989 11.5 11.0922 11.5 12.0707V14.8333C11.5 15.7538 12.2462 16.5 13.1667 16.5H14.8333C15.7538 16.5 16.5 15.7068 16.5 14.7283Z",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.e2d2fb9975717a8a1db863a7f6582864.svg";
export { ForwardRef as ReactComponent };